import styles from '@components/main/css/first-loader.module.css';
import { motion } from 'framer-motion';
import { ReactElement } from 'react';

export default function FirstLoader(): ReactElement {
	return (
		<div className={styles.loader}>
			<motion.div
				className={styles.box}
				animate={{
					scale: [1, 2, 2, 1, 1],
					rotate: [0, 0, 180, 180, 0],
					borderRadius: ['0%', '0%', '50%', '50%', '0%'],
				}}
				transition={{
					duration: 2,
					ease: 'easeInOut',
					times: [0, 0.2, 0.5, 0.8, 1],
					repeat: Infinity,
					repeatDelay: 1,
				}}
			/>
		</div>
	);
}
